<template>
    <div>
        <b-card :style="{'max-width': '2000px', 'width': '100%', 'margin-left': 'auto', 'margin-right': 'auto', 'margin-top': '10px'}">
            <b-card-text>
                <h4>INVENTORY MOVE LOGS</h4>
                <div style="display: inline-block; vertical-align: top;"><b-alert variant="primary" show><sub>This view shows all the inventory movement record as recorded on the system.</sub></b-alert></div>

                <div style="display: inline-block; vertical-align: top;" class="ml-0 ml-md-3">
                    <div style="display: inline-block; vertical-align: top; padding-top: 10px;">
                        <b-button variant="outline-dark" @click="adjust('previous')">PREVIOUS</b-button>
                    </div>
                    <div style="display: inline-block; vertical-align: top; padding-top: 10px;">
                        <b-button variant="outline-dark" @click="adjust('next')">NEXT</b-button>
                    </div>
                </div>

                <div style="display: inline-block; vertical-align: top; max-width: 400px; width: 100%;" class="ml-0 ml-lg-3">
                    <b-form @submit="fetch_init" style="margin-top: 10px;">
                        <b-form-input v-model="search_txt"></b-form-input>
                    </b-form>
                </div>
            </b-card-text>
            <div>
                <loading :active="items_being_loaded"
                    :can-cancel="false"
                    :is-full-page="true">
                </loading>

                <div v-if="items.length > 0" style="margin-top: 10px; overflow-x: auto;">
                    <table class="text-monospace" style="width: 100%; margin-top: 10px;">
                        <thead>
                            <tr style="background: #c3cdd3;">
                                <th class="ipt_tdhr" style="min-width: 100px;" v-on:click="sortby('ts')">
                                    DATE/TIME
                                </th>
                                <th class="ipt_tdhr" style="min-width: 150px;" v-on:click="sortby('product_sku')">
                                    SKU
                                </th>
                                <th class="ipt_tdhr" style="min-width: 250px;" v-on:click="sortby('product_name')">
                                    PRODUCT DESC
                                </th>
                                <th class="ipt_tdhr" style="min-width: 50px;" v-on:click="sortby('move_quantity')">
                                    QTY
                                </th>
                                <th class="ipt_tdhr" style="min-width: 100px;" v-on:click="sortby('source_locsub')">
                                    FROM
                                </th>
                                <th class="ipt_tdhr" style="min-width: 200px;" v-on:click="sortby('target_locsub')">
                                    TO
                                </th>

                                <th class="ipt_tdhr" style="min-width: 100px;" v-on:click="sortby('username')">
                                    BY
                                </th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr v-for="item, idx in items" v-bind:key="idx">
                                <td class="ipt_tdr">
                                    {{ item.ts }}
                                </td>

                                <td class="ipt_tdr">
                                    {{ item.product_sku }}
                                </td>

                                <td class="ipt_tdr">
                                    {{ item.product_name }}
                                </td>

                                <td class="ipt_tdr">
                                    {{ item.quantity }}
                                </td>

                                <td class="ipt_tdr">
                                    <div v-if="item.source_locsub == '-1|-1'">
                                        MANUAL
                                    </div>
                                    <div v-else>
                                        {{ packet.locsubsdict[item.source_locsub] }}
                                    </div>
                                </td>

                                <td class="ipt_tdr">
                                    {{ packet.locsubsdict[item.target_locsub] }}
                                </td>

                                <td class="ipt_tdr">
                                    {{ item.username }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div v-else>
                    <b-alert show variant="warning">No records</b-alert>
                </div>
            </div>
        </b-card>
    </div>
</template>

<script>
    import flatPickr from "vue-flatpickr-component";
    import "flatpickr/dist/flatpickr.css";

    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';

    import moment from "moment"
    import global_vars from "@/utilities/global_vars"
    import Backer from "@/components/globals/Backer"
    import Requestor from "@/utilities/Requestor"

    export default {
        name: "InventoryMoveLogs",
        components: {Backer, flatPickr, Loading},
        data: function() {
            return {
                packet: {},
                sort_asc: false,
                items: [],
                items_being_loaded: false,
                search_txt: '',
                limit: 100,
                offset: 0
            }
        },
        methods: {
            adjust: function(action){
                if (action == "next"){
                    this.offset += 100;
                }
                if (action == "previous"){
                    if (this.offset - 100 <= 0){
                        this.offset = 0;
                    }
                    else {
                        this.offset -= 100;
                    }
                }
                this.fetch_init();
                return
            },
            fetch_init: function(e){
                if (e){
                    e.preventDefault();
                }
                let that = this;
                let path = "/api/inventory/get_inventory_move_logs/"
                let data = {}
                if (this.search_txt){
                    data.search_txt = this.search_txt;
                }
                else {
                    data.limit = this.limit;
                    data.offset = this.offset;
                }

                if (this.packet.userDetails.properties.location_id){
                    data.location_id = this.packet.userDetails.properties.location_id;
                }

                let s = function(response){
                    if (response.data.error){
                        that.$bvToast.toast(
                            response.data.error,
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    else {
                        that.items = response.data.result;
                        if (that.packet.userDetails.userrole != 'admin'){
                            let location_id = (that.packet.userDetails.properties ||{}).location_id;
                            if (location_id){
                                that.items = that.items.filter(function(d) { return +d.source_locsub.split("|")[0] == location_id  || +d.target_locsub.split("|")[0] == location_id });
                            }
                        }
                    }
                    that.items_being_loaded = false;
                }
                let f =  function(error){
                    that.$bvToast.toast(
                        "Error loading inventory move logs.",
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                    that.items_being_loaded = false
                }
                this.items_being_loaded = true;
                this.items = []
                Requestor.getAsync(path, data, s, f);
            },
            sortby: function(key){
                if (this.sort_asc){
                    this.items = Requestor.sort(this.items, key)
                }
                else {
                    this.items = Requestor.sort_reverse(this.items, key)
                }
                this.sort_asc = !this.sort_asc;
            }
        },
        created: function() {
            this.packet = JSON.parse(localStorage.packet);
            this.packet.userDetails = JSON.parse(localStorage.userDetails);
            this.fetch_init();
        }
    }
</script>

<style scoped>
    .non-header {
        font-weight: normal;
        font-size: 12px;
    }

    .ipt_tdhr {
        font-weight: normal;
        font-size: 13px;
        background: silver;
    }

    .ipt_tdr {
        font-weight: normal;
        font-size: 13px;
        background: aliceblue;
    }
</style>



// WEBPACK FOOTER //
// src/components/Inventory/InventoryMoveLogs.vue